import React, { createContext, useContext, ReactNode } from 'react';
import type { ViewStateParams } from 'utils/viewStateDeepLink';

export type GetCurrentViewState = () => ViewStateParams;

const ViewStateContext = createContext<GetCurrentViewState | null>(null);

interface ViewStateProviderProps {
  children: ReactNode;
  getCurrentViewState: GetCurrentViewState;
}

export const ViewStateProvider: React.FC<ViewStateProviderProps> = ({
  children,
  getCurrentViewState
}) => (
  <ViewStateContext.Provider value={getCurrentViewState}>
    {children}
  </ViewStateContext.Provider>
);

/**
 * Returns getCurrentViewState from the nearest ViewStateProvider, or null if none.
 */
export const useViewState = (): GetCurrentViewState | null => {
  return useContext(ViewStateContext);
};
